import { useEffect } from "react";

const LOCK_CLASS = "embed-scroll-locked";
const PADDING_PROP = "paddingRight";

export function measureScrollbarWidth(): number {
  if (typeof window === "undefined") {
    return 0;
  }
  return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
}

export function useBodyScrollLock(locked: boolean): void {
  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;

    if (locked) {
      const gutter = measureScrollbarWidth();
      if (gutter > 0) {
        body.style[PADDING_PROP] = `${gutter}px`;
      }
      root.classList.add(LOCK_CLASS);
    } else {
      root.classList.remove(LOCK_CLASS);
      body.style[PADDING_PROP] = "";
    }

    return () => {
      root.classList.remove(LOCK_CLASS);
      body.style[PADDING_PROP] = "";
    };
  }, [locked]);
}
